import axios from "axios";
// Relative, not the bare "constants" specifier — see customer-ledger.service.ts.
import { API_URL } from "../constants";
import { CustomerProductsResponse } from "types/CustomerProducts";

/** `range` null = the customer's whole history; otherwise only documents dated from..to (both days included). */
export const fetchCustomerProducts = (
  companyId: string,
  customerId: string,
  range: { from: string; to: string } | null
): Promise<CustomerProductsResponse> =>
  axios
    .get(`${API_URL}/${companyId}/customers/${customerId}/products`, {
      params: range ?? undefined,
    })
    .then((response) => response.data);
